module.exports = __webpack_public_path__ + "img/en.593a62e5.svg";